import { OnNodesChange, NodeChange } from "@xyflow/react";

import { BlockType } from "../../../types";
import { useWorkflow } from "../../workflow-context";

import { useDeleteWorkflowNode } from "@/queries";

const useStateMirroring = (onNodesChange: OnNodesChange) => {
  const workflow = useWorkflow();
  const { isSidebarOpen, activeNodeId } = workflow;
  const { mutate: deleteWorkflowNode } = useDeleteWorkflowNode(workflow.userToken!);

  return (changes: NodeChange[]) => {
    changes.forEach(change => {
      // eslint-disable-next-line default-case
      switch (change.type) {
        case "position":
          workflow.updateNodePosition(change.id, change.position as { x: number; y: number });
          break;
        case "remove":
          if (activeNodeId === change.id) {
            workflow.removeActiveNode();
            workflow.closeSidebar();
          }
          workflow.removeNode(change.id);
          deleteWorkflowNode(change.id!, {
            onSuccess: () => undefined,
          });
          break;

        case "add": {
          const newNode = workflow.addNode({
            id: change.item.id,
            name: change.item.data.label as string,
            node_type: change.item.data.type as BlockType,
            configuration: {
              ...(change.item.data.configuration || {}),
              position: change.item.position,
            },
            dependencies: (change.item.data.dependencies as string[]) || [],
            workflow_version_id: workflow.version_id!,
            is_output_node: false,
            has_default_name: change.item.data.has_default_name !== false,
          });
          workflow.setActiveNode(newNode);
          if (!isSidebarOpen) {
            workflow.openSidebar();
          }
          break;
        }
        case "replace": {
          const prev = workflow.getNodeById(change.item.id);
          workflow.replaceNode(change.item.data.label as string, {
            name: change.item.data.label as string,
            node_type: change.item.data.type as BlockType,
            status: prev?.status,
            configuration: prev?.configuration || {},
            dependencies: prev?.dependencies || [],
            is_output_node: prev?.is_output_node || false,
            workflow_version_id: workflow.version_id,
            saved: !change.item.data.unsaved,
          });
          break;
        }
      }
    });
    return onNodesChange(changes);
  };
};

export default useStateMirroring;
